import axios from 'axios';

const baseApiUrl = 'api/admin/jobs';

export default class JobsService {
  public findRecent(filters?: { state?: string; job?: string; from?: string; to?: string }): Promise<any> {
    const params: any = {};
    if (filters) {
      if (filters.state) params.state = filters.state;
      if (filters.job) params.job = filters.job;
      if (filters.from) params.from = filters.from;
      if (filters.to) params.to = filters.to;
    }
    return new Promise((resolve, reject) => {
      axios
        .get(baseApiUrl, { params })
        .then(res => resolve(res.data))
        .catch(err => reject(err));
    });
  }

  public findRecurring(): Promise<any> {
    return new Promise((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/recurring`)
        .then(res => resolve(res.data))
        .catch(err => reject(err));
    });
  }

  public findServers(): Promise<any> {
    return new Promise((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/servers`)
        .then(res => resolve(res.data))
        .catch(err => reject(err));
    });
  }

  public findJob(id: string): Promise<any> {
    return new Promise((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/${id}`)
        .then(res => resolve(res.data))
        .catch(err => reject(err));
    });
  }
}
